import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  Tooltip,
  styled,
} from "@mui/material";
import { FC } from "react";
import useCustomCladColorInput from "./useCustomCladColorInput";

const StyledIconButton = styled(IconButton)({
  width: 21,
  height: 21,
  padding: 0,
  "& .MuiSvgIcon-root": { fontSize: 21 },
});

const StyledErrIcon = styled(ErrorIcon)({
  color: "crimson",
  fontSize: 20,
  marginRight: 10,
});

const StyledInfoIcon = styled(InfoIcon)({
  color: "gray",
  fontSize: 20,
  marginRight: 10,
});

const Loader: FC = () => {
  return (
    <div style={{ width: 18, height: 18, marginLeft: 10 }}>
      <CircularProgress size={18} color="primary" />
    </div>
  );
};

interface CustomCladColorInputProps {
  quoteId: string;
  initialCustomCladColorPrice: number | null;
  customCladColorPriceUpdateRequired?: boolean;
}

export const CustomCladColorInput: FC<CustomCladColorInputProps> = ({
  quoteId,
  initialCustomCladColorPrice,
  customCladColorPriceUpdateRequired,
}) => {
  const {
    customCladColorPrice,
    handleEditCustomCladColorPriceClick,
    editCustomCladColorPriceClicked,
    handleConfirmCustomCladColorPriceClick,
    isUpdatingCustomCladColorPrice,
    handleCustomCladColorPriceChange,
    handleCustomCladColorPriceBlur,
    handleCustomCladColorPriceClickAway,
  } = useCustomCladColorInput(quoteId, initialCustomCladColorPrice);

  return (
    <ClickAwayListener onClickAway={handleCustomCladColorPriceClickAway}>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        {customCladColorPriceUpdateRequired ? (
          <Tooltip
            title="Please update custom clad color price due to the amount of custom clad color panels/units!"
            placement="top"
            enterTouchDelay={0}
          >
            <StyledErrIcon />
          </Tooltip>
        ) : (
          <Tooltip
            title="Custom Clad Color price can be updated due to the amount of custom clad color panels/units."
            placement="top"
            enterTouchDelay={0}
          >
            <StyledInfoIcon />
          </Tooltip>
        )}
        <input
          maxLength={20}
          style={{ width: 75 }}
          value={customCladColorPrice}
          onChange={(e) => handleCustomCladColorPriceChange(e)}
          onBlur={handleCustomCladColorPriceBlur}
          name="customCladColorPrice"
          type="text"
          placeholder=""
          disabled={
            !editCustomCladColorPriceClicked || isUpdatingCustomCladColorPrice
          }
        />
        {!editCustomCladColorPriceClicked ? (
          <StyledIconButton
            style={{ marginLeft: 10 }}
            onClick={handleEditCustomCladColorPriceClick}
          >
            <EditIcon color={"cyan" as "primary"} />
          </StyledIconButton>
        ) : !isUpdatingCustomCladColorPrice ? (
          <StyledIconButton
            style={{ marginLeft: 10 }}
            onClick={() => handleConfirmCustomCladColorPriceClick()}
            disabled={customCladColorPrice === "2222.00"}
          >
            <CheckIcon color={"cyan" as "primary"} />
          </StyledIconButton>
        ) : (
          <Loader />
        )}
      </div>
    </ClickAwayListener>
  );
};
